/** Phaser texture keys for exploration room art (must match BootScene preload). */
export const ROOM_BACKGROUND_KEYS = [
  'bg_safe_room',
  'bg_enemy_room',
  'bg_npc_room',
  'bg_treasure_room',
  'bg_trap_room',
  'bg_secret_room',
  'bg_boss_room',
  'bg_teleporter_room',
] as const;

export type RoomBackgroundKey = (typeof ROOM_BACKGROUND_KEYS)[number];

export function backgroundAssetPath(key: string): string {
  return `/assets/backgrounds/${key}.png`;
}
